import ITransferenciaContaBancariaRequestDTO from '../entities/ITransferenciaContaBancariaRequestDTO'
import ITransferenciaContaBancariaResponseDTO from '../entities/ITransferenciaContaBancariaResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface ITransferenciaContaBancaria {
  execute(
    data: ITransferenciaContaBancariaRequestDTO,
  ): Promise<ITransferenciaContaBancariaResponseDTO>
}

export default class TransferenciaContaBancariaImpl
  implements ITransferenciaContaBancaria
{
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(
    data: ITransferenciaContaBancariaRequestDTO,
  ): Promise<ITransferenciaContaBancariaResponseDTO> {
    const response = await this.pagamentoRepository.transferToBankAccount(data)
    return response
  }
}
